import { LookupList } from '@domain'

import api from '.'

// Query Key factory
export const LookupsKey = {
	all: ['lookups'],
}

const LookupsApi = {
	getAll: () => api.get<APIRes<LookupList>>('/lookups').then((res) => res.data.data),
}

export default LookupsApi
